"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const Filter = createSvgIcon(
  <path d="M10.5577 17V16H13.4231V17H10.5577ZM6.80768 12.5V11.5H17.1731V12.5H6.80768ZM4 8V7H20V8H4Z" />,
  "Filter",
)

const FilterIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <Filter sx={{ fill: _fill, ...sx }} {...rest} />
}

export default FilterIcon
